import { QuestionnaireStatus } from '@/gen/questionnaire/common/v1/questionnaire_status_pb'

export const smartEvidenceRequestStatusLabel: Record<QuestionnaireStatus, string> = {
  [QuestionnaireStatus.UNSPECIFIED]: 'Closed',
  [QuestionnaireStatus.ONGOING]: 'Open',
  [QuestionnaireStatus.COMPLETED]: 'Closed',
  [QuestionnaireStatus.EXPIRED]: 'Expired',
  [QuestionnaireStatus.DRAFT]: 'Not shared',
  [QuestionnaireStatus.SUBMITTED]: 'Submitted',
}
